<template>
  <div class="user-levels-list">
    <div v-show="!userLevels.length" class="no-exercises-message">
      <h2 class="headline">You haven't yet created any exercises.</h2>
      <p>
        Click on the big red dot with the plus sign to add your own custom
        exercises
      </p>
      <!-- Put ad here?? -->
    </div>

    <v-list
      v-show="userLevels.length"
      two-line
      subheader
      class="scrollable-levels user-levels"
    >
      <div v-for="(level, i) in userLevels" :key="i">
        <v-list-tile
          avatar
          :class="{
            grey: levelSelected === level.id,
            'lighten-3': levelSelected === level.id,
          }"
          @click="showLevelInfo(level)"
        >
          <v-list-tile-action>
            <!-- Actions menu -->
            <v-menu
              bottom
              right
              @click.native.stop="setClickedLevelId"
              origin="top left"
              transition="scale-transition"
            >
              <v-btn slot="activator" icon>
                <v-icon :id="i">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  @click="performAction(item.title)"
                  avatar
                >
                  <v-list-tile-avatar>
                    <v-icon medium color="grey lighten-1">{{
                      item.icon
                    }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ level.title }}</v-list-tile-title>
            <v-list-tile-sub-title>{{
              level.description
            }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-list-tile-action-text
              >{{ level.score }}%</v-list-tile-action-text
            >
            <v-progress-circular
              :value="level.score"
              color="green"
            ></v-progress-circular>
          </v-list-tile-action>

          <v-icon
            @click="toggleDescriptionList"
            v-if="breakpoint.xsOnly"
            large
            class="ml-2"
            >chevron_right</v-icon
          >
        </v-list-tile>

        <!-- ********* DIALOGS ********** -->
        <!-- Share Dialog -->
        <v-dialog v-model="showShareLinkDialog" max-width="600px">
          <v-card>
            <v-card-title class="headline">Share Exercise Link</v-card-title>
            <v-card-text>
              <v-text-field
                solo
                flat
                background-color="#eee"
                single-line
                hide-details
                append-outer-icon="content_copy"
                @click:append-outer="copyLink"
                :value="shareExerciseURL"
                class="pa-0 ma-0"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="teal darken-1"
                flat
                @click="showShareLinkDialog = false"
                >Done</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Copy level dialog -->
        <v-dialog v-model="copyExerciseDialog" max-width="500px">
          <v-card>
            <v-card-title class="headline">Copy Exercise</v-card-title>
            <v-card-text>
              <v-text-field
                color="teal darken-1"
                v-model="titleOfCopy"
                autofocus
                label="Enter a new title for this exercise"
                required
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="teal darken-1"
                flat
                @click="copyExerciseDialog = false"
                >Close</v-btn
              >
              <v-btn color="teal darken-1" flat @click="copyExercise()"
                >Copy</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- END Copy level dialog -->
        <!-- Delete level dialog -->
        <v-dialog v-model="deleteLevelDialog" max-width="300px">
          <v-card>
            <v-card-title class="headline">Delete Exercise</v-card-title>
            <v-card-text
              >Are you sure you want to delete this exercise?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="teal darken-1"
                flat
                @click="deleteLevelDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="red darken-1" flat @click="deleteExercise"
                >Delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- END Delete level dialog -->
        <v-divider></v-divider>
      </div>
    </v-list>

    <!-- Create new exercise button -->
    <v-btn @click="addExercise" class="red add-user-exercise-button" dark fab>
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import firebase from "firebase";
import { createUID } from '@/assets/create-unique-id.js';
export default {
  name: "UserLevelsList",
  data() {
    return {
      levelSelected: null,
      copyExerciseDialog: false,
      deleteLevelDialog: false,
      showShareLinkDialog: false,
      shareLink:
        "http://localhost:8080/#/identify-intervals/exercise/user/?usr=ONYad1VKz8P4ipBKc7GWDbRBQ0C2&type=2&id=2",
      actionButtonClickedID: null,
      titleOfCopy: "",
      items: [
        { title: "Edit", icon: "edit" },
        { title: "Copy", icon: "content_copy" },
        { title: "Share Link", icon: "share" },
        { title: "Delete", icon: "delete" },
      ],
    };
  },
  methods: {
    setClickedLevelId(event) {
      this.actionButtonClickedID = event.target.id;
    },
    showLevelInfo(level, i) {
      // Set the selected level to highlight it
      this.levelSelected = level.id;
      this.$store.dispatch("setCurrentlySelectedLevel", {
        type: "user",
        level: level,
      });
    },
    performAction(action) {
      if (action === "Delete") {
        this.deleteLevelDialog = true;
      }
      if (action === "Share Link") {
        this.showShareLinkDialog = true;
      }
      if (action === "Copy") {
        if (
          this.userLevels.length >= this.$store.state.maxNumberOfUserExercises
        ) {
          this.$store.dispatch("setAlertDialog", {
            showing: true,
            maxWidth: "400px",
            title: "Sorry!",
            text: `You cannot create more than ${this.$store.state.maxNumberOfUserExercises} exercises. Delete some of your existing exercises to make space for new ones.`,
            buttonText: "OK",
          });
          // console.log('Too many added!');
          return;
        } else {
          this.copyExerciseDialog = true;
        }
      }
      if (action === "Edit") {
        this.editExercise();
      }
    },
    deleteExercise() {
      this.$store.dispatch("deleteExercise", this.actionButtonClickedID);
      this.deleteLevelDialog = false;
    },
    editExercise() {
      // Set exercise being edited flag to true
      this.$store.dispatch("setIsExerciseBeingEdited", true);
      let exerciseToEdit = this.$store.getters.getExerciseFromId(
        parseInt(this.actionButtonClickedID)
      ); // the exercise object
      // set the object of the exercise being edited in the store
      this.$store.dispatch("setExerciseBeingEdited", exerciseToEdit);

      let pathToEdit = `${this.$route.path}/edit-exercise/${this.actionButtonClickedID}`;

      this.$router.push({
        path: pathToEdit,
        params: { id: this.actionButtonClickedID },
      });
    },
    copyExercise() {
      this.copyExerciseDialog = false;
      const action = "copy";
      // GET LEVEL TO COPY FROM ID IN ACTION BUTTON CLICKED
      let exerciseToCopy = this.$store.getters.getExerciseFromId(
        parseInt(this.actionButtonClickedID)
      );
      //console.log("Exercise to copy", exerciseToCopy);
      let newExerciseIdAndDisciplineToAddTo = this.$store.getters
        .getUserExerciseIdAndDisciplineToAddTo;

      //check if original exercise title and the new provided are identical
      let copyOfExerciseTitle;
      if (this.titleOfCopy === "") {
        copyOfExerciseTitle = `Copy of ${exerciseToCopy.title}`;
      } else {
        copyOfExerciseTitle = this.titleOfCopy;
        this.titleOfCopy = "";
      }

      this.$store.dispatch("addUserExercise", [
        newExerciseIdAndDisciplineToAddTo.disciplineToAddTo,
        action,
        {
          id: createUID(),
          title: copyOfExerciseTitle,
          description: exerciseToCopy.description,
          harmony: exerciseToCopy.harmony,
          soundSequences: exerciseToCopy.soundSequences,
          score: exerciseToCopy.score,
        },
      ]);
    },
    toggleDescriptionList() {
      this.$store.dispatch("setShowExerciseDescription", true);
      this.$store.dispatch("setShowExerciseList", false);
    },
    addExercise() {
      if (
        this.userLevels.length >= this.$store.state.maxNumberOfUserExercises
      ) {
        this.$store.dispatch("setAlertDialog", {
          showing: true,
          maxWidth: "400px",
          title: "Sorry!",
          text: `You cannot create more than ${this.$store.state.maxNumberOfUserExercises} exercises. Delete some of your existing exercises to make space for new ones.`,
          buttonText: "OK",
        });
        // console.log('Too many added!');
        return;
      } else {
        this.setupCreateExerciseMobileView();
        this.$router.push(this.$route.path + "/create-exercise");
      }
    },
    setupCreateExerciseMobileView() {
      if (this.breakpoint.width < 600) {
        // Small screen
        this.$store.dispatch("setShowCreateExerciseSoundSequenceList", true);
        this.$store.dispatch("setShowCreateExerciseSettings", false);
      } else {
        // Not small screen
        this.$store.dispatch("setShowCreateExerciseSoundSequenceList", true);
        this.$store.dispatch("setShowCreateExerciseSettings", true);
      }
    },
    copyLink() {

      navigator.clipboard.writeText(this.shareExerciseURL)
        .then(() => {
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `Link copied to clipboard`
          });
        }).catch((err) => {
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `Sorry, Could not copy link. ${err}`
          });
        });

     
    },
  },
  computed: {
    userLevels() {
      return this.$store.getters.getExerciseList;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    currentRoutePath() {
      return this.$store.getters.getCurrentRoutePath;
    },
    disciplineID() {
      if (this.currentRoutePath === "/compare-interval-sizes") {
        return 1;
      } else if (this.currentRoutePath === "/identify-intervals") {
        return 2;
      } else if (this.currentRoutePath === "/identify-chords") {
        return 3;
      } else if (this.currentRoutePath === "/identify-chord-inversions") {
        return 4;
      } else if (this.currentRoutePath === "/identify-scales") {
        return 5;
      } else {
        return null;
      }
    },
    exerciseID() {
      let clickedExercise = this.$store.getters.getExerciseFromId(
        this.actionButtonClickedID
      );
      if (clickedExercise) {
        return clickedExercise.id;
      } else {
        return null;
      }
    },
    shareExerciseURL() {
      const userID = firebase.auth().currentUser.uid;
      const URLprefix = "https://www.earbeater.com/online-ear-training/#";
      const URLpostfix = "/exercise/user";
      const exerciseID = 2;
      const shareURL = `${URLprefix}${this.currentRoutePath}${URLpostfix}/?usr=${userID}&type=${this.disciplineID}&id=${this.exerciseID}`;
      return shareURL;
    },
  },
  created() {
    let currentlySelectedLevel = this.$store.getters.getCurrentlySelectedLevel;
    // Check if there are no user exercises added yet
    if (currentlySelectedLevel) {
      // Set id of the currently selected level
      this.levelSelected = currentlySelectedLevel.id;
    }
  },
};
</script>

<style>
.user-levels-list {
  position: relative;
}
.user-levels-list .scrollable-levels {
  /* height: calc(100vh - 84px); */
  height: calc(calc(var(--vh, 1vh) * 100) - 84px) !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.user-levels-list .no-exercises-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em;
  height: calc(calc(var(--vh, 1vh) * 100) - 84px) !important;
  background: #fff;
  text-align: center;
}

.level-selector .add-user-exercise-button {
  position: absolute;
  bottom: 10px;
  right: 40px;
}

@media screen and (max-width: 600px) {
  .user-levels-list .scrollable-levels {
    /* height: calc(100vh - 154px)!important; */
    height: calc(calc(var(--vh, 1vh) * 100) - 154px) !important;
  }
  .user-levels-list .no-exercises-message {
    height: calc(calc(var(--vh, 1vh) * 100) - 154px) !important;
  }
}
</style>
